import { Box, Typography } from '@material-ui/core'

const SlideLoader = () => {
  return (
    <>
      <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
        <Typography variant="h3">
          <i className="fa fa-spinner fa-spin"></i>
        </Typography>
        <Typography variant="subtitle1">
          Loading questions ...
        </Typography>
      </Box>
    </>
  )
}

export default SlideLoader